import { downloadToFile } from '@/api/common'

export default {
  // 下载 Excel 方法
  excel(data, fileName) {
    this.download(data, fileName, 'application/vnd.ms-excel');
  },

  // 下载 Word 方法
  word(data, fileName) {
    this.download(data, fileName, 'application/msword');
  },

  // 下载 Zip 方法
  zip(data, fileName) {
    this.download(data, fileName, 'application/zip');
  },

  // 下载 Html 方法
  html(data, fileName) {
    this.download(data, fileName, 'text/html');
  },

  // 下载 Markdown 方法
  markdown(data, fileName) {
    this.download(data, fileName, 'text/markdown');
  },

  download(data, fileName, mineType) {
    // 创建 blob
    let blob = new Blob([data], {type: mineType});
    // 创建 href 超链接，点击进行下载
    window.URL = window.URL || window.webkitURL;
    let href = URL.createObjectURL(blob);
    let downA = document.createElement("a");
    downA.href = href;
    downA.download = fileName;
    downA.click();
    // 销毁超连接
    window.URL.revokeObjectURL(href);
  },
  loadFile(filePath, name, mineType) {
    if(!filePath) return
    let arr = filePath.split('/')
    let name1 = name || arr[arr.length - 1]
    downloadToFile({filePath}).then(res => {
      // this.excel(res, name1);
      this.download(res, name1, mineType)
    })
    // var a = document.createElement('a') // 创建一个<a></a>标签
    // a.href = url //重点（如测试发现下载文件不存在/找不到，检查路径）
    // let arr = url.split('/')
    // let name1 = name || arr[arr.length - 1]
    // a.target = "_blank";
    // a.download = name1 // 设置下载文件文件名
    // a.style.display = 'none' // 隐藏a标签
    // document.body.appendChild(a) // 将a标签追加到文档对象中
    // a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
    // a.remove()
  },

  async loadZip(filePath, name, fileType) {
    if(!filePath) return
    let arr = filePath.split('/')
    let name1 = name || arr[arr.length - 1]
    const res = await downloadToFile({filePath})
    if (fileType == 'zip') {
      // 创建一个新的Blob对象，设置文件类型
      const blob = new Blob([res], { type: 'application/zip' });
      // 创建一个指向Blob的URL
      const url = window.URL.createObjectURL(blob);
      // 创建a标签并设置属性
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name1); // 设置下载文件名
      document.body.appendChild(link);
      // 触发下载
      link.click();
    } else {
      var a = document.createElement('a') // 创建一个<a></a>标签
      a.href = window.URL.createObjectURL(res) //重点（如测试发现下载文件不存在/找不到，检查路径）
      let arr = filePath.split('/')
      let name1 = name || arr[arr.length - 1]
      a.target = "_blank";
      a.download = name1 // 设置下载文件文件名
      a.style.display = 'none' // 隐藏a标签
      document.body.appendChild(a) // 将a标签追加到文档对象中
      a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove()
    }
  }
}